(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767.98px)');
  var records = new WeakMap();

  function getMakeItYoursBlock(root) {
    var note = root.querySelector('.product__info-wrapper .pally-custom-note');
    if (!note) return null;
    return note.closest('.product__block') || note;
  }

  function moveSupportForProduct(root) {
    var support = root.querySelector('.product__media-support');
    if (!support) return;

    if (!records.has(support)) {
      records.set(support, {
        parent: support.parentNode,
        next: support.nextSibling
      });
    }

    if (mobileQuery.matches) {
      var target = getMakeItYoursBlock(root);
      if (target && target.parentNode) {
        target.insertAdjacentElement('afterend', support);
      }
    } else {
      var original = records.get(support);
      if (!original || !original.parent) return;
      if (original.next && original.next.parentNode === original.parent) {
        original.parent.insertBefore(support, original.next);
      } else {
        original.parent.appendChild(support);
      }
    }
  }

  function sync() {
    document.querySelectorAll('body.product-template product-info[id^="MainProduct-"]').forEach(moveSupportForProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  window.addEventListener('load', sync, { once: true });
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', sync);
  else if (mobileQuery.addListener) mobileQuery.addListener(sync);

  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
})();
